/* ============================================================
   POWER LEAK QUIZ — v2 engine (Butcherbird rebuild 2026-08-28)
   White-box replacement for the compiled power-leak-quiz.js.
   Fires the full Meta funnel + Klaviyo. Content is Hiba's verbatim
   (embedded as JSON in templates/page.power-leak-quiz.liquid).
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('plq-root');
  var dataEl = document.getElementById('plq-data');
  if (!root || !dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); }
  catch (e) { console.error('[plq] bad quiz data', e); return; }

  var LEAK_ORDER = ['O', 'F', 'S', 'C'];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── state ────────────────────────────────────────────────
  var answers = [];               // leak key per answered question
  var idx = 0;                    // current question index
  var stepFiftyFired = false;

  // ── Meta pixel helpers (mirror hiba-quiz.js: CAPI-dedup eventID) ──
  function makeEventId(name) {
    var rand = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : (Date.now() + '_' + Math.random().toString(36).slice(2, 10));
    return 'hiba_' + name.toLowerCase() + '_' + rand;
  }
  // fbq is installed site-wide by snippets/hiba-pixel.liquid (Shopify Meta
  // channel, async). Queue events until it resolves so nothing is dropped.
  var fbqReady = (typeof window.fbq === 'function');
  var pending = [];
  function firePixel(name, props) {
    var payload = { name: name, props: props || {}, id: makeEventId(name) };
    if (typeof window.fbq === 'function') {
      try { window.fbq('trackCustom', payload.name, payload.props, { eventID: payload.id }); }
      catch (err) { console.warn('[plq] fbq ' + name + ' error', err); }
    } else {
      pending.push(payload);
    }
  }
  function fireStandard(name, props) {
    var id = makeEventId(name);
    if (typeof window.fbq === 'function') {
      try { window.fbq('track', name, props || {}, { eventID: id }); }
      catch (err) { console.warn('[plq] fbq ' + name + ' error', err); }
    } else {
      pending.push({ standard: true, name: name, props: props || {}, id: id });
    }
  }
  (function pollFbq(attempt) {
    if (typeof window.fbq === 'function') {
      pending.forEach(function (p) {
        try {
          window.fbq(p.standard ? 'track' : 'trackCustom', p.name, p.props, { eventID: p.id });
        } catch (e) {}
      });
      pending = [];
      return;
    }
    if (attempt < 20) setTimeout(function () { pollFbq(attempt + 1); }, 250);
  })(0);

  // ── DOM helper ───────────────────────────────────────────
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else n.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function leakName(k) { return DATA.leaks[k].name; }

  // ── frame (bar + stage + footer) ─────────────────────────
  function frame(stageNode, countLabel) {
    root.innerHTML = '';
    var bar = el('div', { class: 'plq__bar' }, [
      el('a', { class: 'plq__home', href: '/', text: '← Home' }),
      el('span', { class: 'plq__brand', text: 'Power Leaks' }),
      el('span', { class: 'plq__count', text: countLabel || '' })
    ]);
    var rail = el('div', { class: 'plq__rail' }, [
      el('div', { class: 'plq__rail-fill', id: 'plq-rail' })
    ]);
    var stage = el('div', { class: 'plq__stage' }, [
      el('div', { class: 'plq__inner plq-fade' }, [stageNode])
    ]);
    var foot = el('div', { class: 'plq__foot' }, [
      el('span', { text: 'The Invisible Rulebook' }),
      el('span', { text: 'Hiba Balfaqih' })
    ]);
    root.appendChild(el('div', { class: 'plq' }, [bar, rail, stage, foot]));
    setRail(0);
  }
  function setRail(pct) {
    var f = document.getElementById('plq-rail');
    if (f) f.style.right = (100 - pct) + '%';
  }

  // ── INTRO ────────────────────────────────────────────────
  function renderIntro() {
    var i = DATA.intro;
    var node = el('div', { class: 'plq-intro' }, [
      el('p', { class: 'eyebrow', text: i.eyebrow }),
      el('h1', { html: i.headline.replace('power leak', '<span class="hl">power leak</span>') }),
      el('p', { class: 'body', text: i.body }),
      el('p', { class: 'sub', text: i.sub }),
      (function () {
        var b = el('button', { class: 'plq-btn', type: 'button' }, [
          document.createTextNode(i.cta)
        ]);
        b.addEventListener('click', startQuiz);
        return b;
      })()
    ]);
    frame(node, 'The Diagnostic');
  }

  function startQuiz() {
    answers = []; idx = 0; stepFiftyFired = false;
    firePixel('QuizStarted', {
      content_category: 'power-leak',
      content_name: 'power-leak-quiz',
      question_count: DATA.questions.length
    });
    renderQuestion(0);
  }

  // ── QUESTION ─────────────────────────────────────────────
  function renderQuestion(i) {
    idx = i;
    var q = DATA.questions[i];
    var total = DATA.questions.length;
    var opts = el('ul', { class: 'plq-options' }, q.options.map(function (opt, oi) {
      var li = el('li');
      var btn = el('button', { class: 'plq-opt', type: 'button', 'data-leak': opt.leak, text: opt.text });
      btn.addEventListener('click', function () { pick(i, opt.leak, btn); });
      li.appendChild(btn);
      return li;
    }));
    var stage = el('div', { class: 'plq-q' }, [
      el('p', { class: 'qnum', text: 'Question ' + pad(i + 1) + ' / ' + pad(total) }),
      el('h2', { text: q.q }),
      el('div', { class: 'accent-rule' }),
      opts
    ]);
    if (i > 0) {
      var back = el('button', { class: 'plq-back', type: 'button', text: '← Back' });
      back.addEventListener('click', function () { answers.pop(); renderQuestion(i - 1); });
      stage.appendChild(back);
    }
    frame(stage, pad(i + 1) + ' / ' + pad(total));
    setRail(Math.round((i / total) * 100));
  }

  function pick(i, leak, btn) {
    btn.classList.add('is-picked');
    answers[i] = leak;
    firePixel('QuizQuestionAnswered', {
      question_index: i + 1,
      leak: leakName(leak),
      content_category: 'power-leak'
    });
    var total = DATA.questions.length;
    if (!stepFiftyFired && (i + 1) >= Math.ceil(total / 2)) {
      stepFiftyFired = true;
      firePixel('QuizStep_50', { content_category: 'power-leak' });
    }
    setRail(Math.round(((i + 1) / total) * 100));
    var delay = reduce ? 60 : 240;   // let the pick register visually
    setTimeout(function () {
      if (i + 1 < total) renderQuestion(i + 1);
      else renderResult();
    }, delay);
  }

  // ── RESULT ───────────────────────────────────────────────
  function tally() {
    var counts = { O: 0, F: 0, S: 0, C: 0 };
    answers.forEach(function (k) { if (counts.hasOwnProperty(k)) counts[k]++; });
    return counts;
  }
  function dominantOf(counts) {
    var best = LEAK_ORDER[0];
    LEAK_ORDER.forEach(function (k) { if (counts[k] > counts[best]) best = k; });
    return best;
  }

  function renderResult() {
    var counts = tally();
    var dom = dominantOf(counts);
    var leak = DATA.leaks[dom];
    var total = DATA.questions.length;
    var R = DATA.result;

    // events — QuizCompleted feeds CC 2130754541194862
    firePixel('QuizCompleted', {
      content_category: 'power-leak',
      content_name: 'power-leak-quiz',
      dominant_leak: leak.name,
      count_obedience: counts.O, count_fear: counts.F,
      count_scarcity: counts.S, count_control: counts.C
    });
    firePixel('ResultViewed', { content_category: 'power-leak', dominant_leak: leak.name });

    // verdict
    var verdict = el('div', { class: 'plq-verdict' }, [
      el('h1', { text: leak.name }),
      el('span', { class: 'verb', text: leak.verb + '.' })
    ]);

    // four doors distribution (dominant first, then by count desc)
    var ordered = LEAK_ORDER.slice().sort(function (a, b) {
      if (a === dom) return -1; if (b === dom) return 1;
      return counts[b] - counts[a];
    });
    var doorNodes = ordered.map(function (k, i) {
      var d = el('div', { class: 'plq-door' + (k === dom ? ' is-dominant' : '') }, [
        el('span', { class: 'rank', text: pad(i + 1) }),
        el('span', { class: 'dname', text: leakName(k) }),
        el('span', { class: 'track' }, [el('span', { class: 'fill', 'data-pct': Math.round((counts[k] / total) * 100) })]),
        el('span', { class: 'dcount', html: '<b class="num" data-to="' + counts[k] + '">0</b> of ' + total })
      ]);
      return d;
    });
    var doors = el('div', { class: 'plq-doors' }, doorNodes);

    // diagnosis
    var thesisHTML = escapeHTML(leak.thesis);
    var diag = el('div', { class: 'plq-block' }, [
      el('p', { class: 'eyebrow eyebrow--muted', text: 'What this means' }),
      el('h2', { class: 'plq-thesis', html: thesisHTML }),
      el('p', { class: 'plq-body', text: leak.body }),
      el('div', { class: 'plq-move' }, [
        el('span', { class: 'lbl', text: R.moveLabel }),
        el('p', { text: leak.move })
      ])
    ]);

    // room bridge
    var roomUrl = DATA.routing[dom];
    var buy = el('button', { class: 'plq-btn', type: 'button' }, [
      document.createTextNode(R.bridgeCta + ' '),
      el('span', { class: 'price', text: '→ ' + R.price })
    ]);
    buy.addEventListener('click', function () { window.location.href = roomUrl; });
    var bridge = el('div', { class: 'plq-block' }, [
      el('div', { class: 'plq-bridge' }, [
        el('div', {}, [
          el('p', { class: 'eyebrow eyebrow--muted', text: R.bridgeEyebrow }),
          el('h3', { text: 'A guided audio that seals the door ' + leak.name.toLowerCase() + ' keeps open.' }),
          el('p', { class: 'rblurb', text: leak.blurb }),
          buy
        ]),
        (function () {
          if (leak.image) {
            return el('div', { class: 'plq-cover plq-cover--img', 'aria-hidden': 'true' }, [
              el('img', { class: 'plq-cover__img', src: leak.image, alt: '', loading: 'lazy', decoding: 'async' })
            ]);
          }
          return el('div', { class: 'plq-cover', 'aria-hidden': 'true' }, [
            el('span', { class: 'ck', text: 'Guided Reprogramming' }),
            el('span', { class: 'cbig', text: leak.name }),
            el('span', { class: 'cfoot', text: 'Seal the door. Take back the power.' })
          ]);
        })()
      ])
    ]);

    // email gate
    var input = el('input', { type: 'email', placeholder: R.gatePlaceholder, 'aria-label': 'Your email', required: 'required' });
    var submit = el('button', { type: 'submit', text: R.gateButton + ' →' });
    var done = el('p', { class: 'plq-done', text: R.gateDone });
    done.style.display = 'none';
    var form = el('form', { class: 'plq-form' }, [input, submit]);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!email || email.indexOf('@') === -1) { input.focus(); return; }
      submit.disabled = true; submit.textContent = 'Sending…';
      subscribeKlaviyo(email, dom, counts);
      fireStandard('Lead', {
        content_category: leak.name.toLowerCase(),
        content_name: 'power-leak-' + leak.name.toLowerCase()
      });
      form.style.display = 'none';
      done.style.display = 'block';
    });
    var gate = el('div', { class: 'plq-gate' }, [
      el('div', { class: 'plq-gate-inner' }, [
        el('p', { class: 'eyebrow', text: R.gateEyebrow }),
        el('h3', { text: R.gateHeadline }),
        el('p', { class: 'gsub', text: R.gateSub }),
        form, done
      ])
    ]);

    // bundle
    var bundleLink = el('a', { class: 'plq-textlink', href: '/products/the-reprogramming-bundle' }, [
      document.createTextNode(R.bundleCta + ' · the bundle →')
    ]);
    var bundle = el('div', { class: 'plq-bundle plq-block' }, [
      el('p', { class: 'eyebrow eyebrow--muted', text: R.bundleEyebrow }),
      el('p', { text: leak.name + ' ' + R.bundleLine.replace('This', '').trim() }),
      bundleLink
    ]);

    var stage = el('div', { class: 'plq-result' }, [
      el('p', { class: 'eyebrow', text: R.eyebrow }),
      el('p', { class: 'lede', text: R.lede }),
      verdict, doors,
      el('p', { class: 'plq-note', text: 'Most women have one door running the show. The majority have more. This is where you leak the most.' }),
      diag, bridge, gate, bundle
    ]);
    frame(stage, 'Complete');
    setRail(100);
    animateDoors();
  }

  function animateDoors() {
    var fills = root.querySelectorAll('.plq-door .fill');
    var nums = root.querySelectorAll('.plq-door .num');
    fills.forEach(function (f, i) {
      var pct = +f.getAttribute('data-pct');
      var delay = reduce ? 0 : 180 + i * 120;
      setTimeout(function () { f.style.right = (100 - pct) + '%'; }, delay);
    });
    nums.forEach(function (n, i) {
      var to = +n.getAttribute('data-to');
      if (reduce) { n.textContent = to; return; }
      var delay = 180 + i * 120, start = null, dur = 650;
      setTimeout(function () {
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          n.textContent = Math.round(p * to);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, delay);
    });
  }

  // ── Klaviyo subscription (mirrors Hiba's original payload) ──
  function subscribeKlaviyo(email, dom, counts) {
    var listId = DATA.klaviyo.lists[dom];
    var company = DATA.klaviyo.company;
    if (!listId || !company) return;
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + company, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: { dominant_leak: DATA.leaks[dom].name, leak_counts: counts }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }).catch(function () {});
    } catch (e) {}
  }

  // ── utils ────────────────────────────────────────────────
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function escapeHTML(s) {
    var d = document.createElement('div'); d.textContent = s;
    return d.innerHTML;
  }

  renderIntro();
})();
